<template>
  <div class="navigation-group-deeplink-component">
    <div class="list-container">
      <router-link
        v-for="item in navigationItems"
        :key="item.id"
        :to="{ ...item.route, query: nestedQuery(item)}"
        class="row"
      >
        <div class="name">
          {{ item.name }}
        </div>
        <icon
          name="arrow"
          class="arrow"
          variant="4fb9de"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';
import GlobalMixin from '@/mixins/global';

export default {
  components: { Icon },
  mixins: [GlobalMixin],
  computed: {
    navigationGroup() {
      return this.$store.getters['navigationGroups/navigationGroups'][this.$route.params.navigationGroupId] || {};
    },
    navigationItems() {
      if(this.$route.params.id) {
        return this.$store.getters['navigationItems/navigationItemsList'].filter(ni => ni.navigationGroupId == this.$route.params.id);
      } else {
        return this.$store.getters['navigationItems/navigationItemsList'].filter(ni => ni.navigationGroupId == this.navigationGroup.id);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
  $heading-color: $grey-2 !default;

  .navigation-group-deeplink-component {
    background-color: $blue-2;
    @include full-padding;

    .heading {
      color: $heading-color;
      display: flex;
      font-size: rem-calc(18);
      font-weight: $semi-bold;
      margin-bottom: rem-calc(28);
    }

    .name {
      flex: 1;
    }
  }
</style>
